// ISO 3166-1 alpha-2 country list. India is pinned to the top because it's
// the most common selection for this product; everything else is alphabetical.

export const COUNTRIES = [
  { code: "IN", name: "India" },
  // ── A
  { code: "AF", name: "Afghanistan" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  // ── B
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BR", name: "Brazil" },
  { code: "BN", name: "Brunei" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  // ── C
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "CV", name: "Cape Verde" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo" },
  { code: "CD", name: "Congo (DRC)" },
  { code: "CR", name: "Costa Rica" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czechia" },
  // ── D
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  // ── E
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Ethiopia" },
  // ── F
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  // ── G
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GR", name: "Greece" },
  { code: "GD", name: "Grenada" },
  { code: "GT", name: "Guatemala" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  // ── H
  { code: "HT", name: "Haiti" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  // ── I
  { code: "IS", name: "Iceland" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  // ── J
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JO", name: "Jordan" },
  // ── K
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  // ── L
  { code: "LA", name: "Laos" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  // ── M
  { code: "MO", name: "Macau" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "MX", name: "Mexico" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar" },
  // ── N
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "KP", name: "North Korea" },
  { code: "MK", name: "North Macedonia" },
  { code: "NO", name: "Norway" },
  // ── O
  { code: "OM", name: "Oman" },
  // ── P
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestine" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  // ── Q
  { code: "QA", name: "Qatar" },
  // ── R
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russia" },
  { code: "RW", name: "Rwanda" },
  // ── S
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "KR", name: "South Korea" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syria" },
  // ── T
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" },
  { code: "TG", name: "Togo" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad and Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turkey" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TV", name: "Tuvalu" },
  // ── U
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  // ── V
  { code: "VU", name: "Vanuatu" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  // ── Y
  { code: "YE", name: "Yemen" },
  // ── Z
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];

export const COUNTRY_NAMES = Object.fromEntries(COUNTRIES.map((c) => [c.code, c.name]));

// Common dial codes — India first, then alphabetical by country name.
export const DIAL_CODES = [
  { dial: "+91",  name: "India" },
  { dial: "+93",  name: "Afghanistan" },
  { dial: "+355", name: "Albania" },
  { dial: "+213", name: "Algeria" },
  { dial: "+54",  name: "Argentina" },
  { dial: "+61",  name: "Australia" },
  { dial: "+43",  name: "Austria" },
  { dial: "+973", name: "Bahrain" },
  { dial: "+880", name: "Bangladesh" },
  { dial: "+32",  name: "Belgium" },
  { dial: "+55",  name: "Brazil" },
  { dial: "+1",   name: "Canada / USA" },
  { dial: "+86",  name: "China" },
  { dial: "+45",  name: "Denmark" },
  { dial: "+20",  name: "Egypt" },
  { dial: "+251", name: "Ethiopia" },
  { dial: "+358", name: "Finland" },
  { dial: "+33",  name: "France" },
  { dial: "+49",  name: "Germany" },
  { dial: "+233", name: "Ghana" },
  { dial: "+30",  name: "Greece" },
  { dial: "+852", name: "Hong Kong" },
  { dial: "+36",  name: "Hungary" },
  { dial: "+62",  name: "Indonesia" },
  { dial: "+98",  name: "Iran" },
  { dial: "+964", name: "Iraq" },
  { dial: "+353", name: "Ireland" },
  { dial: "+972", name: "Israel" },
  { dial: "+39",  name: "Italy" },
  { dial: "+81",  name: "Japan" },
  { dial: "+962", name: "Jordan" },
  { dial: "+254", name: "Kenya" },
  { dial: "+965", name: "Kuwait" },
  { dial: "+856", name: "Laos" },
  { dial: "+961", name: "Lebanon" },
  { dial: "+60",  name: "Malaysia" },
  { dial: "+960", name: "Maldives" },
  { dial: "+52",  name: "Mexico" },
  { dial: "+212", name: "Morocco" },
  { dial: "+95",  name: "Myanmar" },
  { dial: "+977", name: "Nepal" },
  { dial: "+31",  name: "Netherlands" },
  { dial: "+64",  name: "New Zealand" },
  { dial: "+234", name: "Nigeria" },
  { dial: "+47",  name: "Norway" },
  { dial: "+968", name: "Oman" },
  { dial: "+92",  name: "Pakistan" },
  { dial: "+63",  name: "Philippines" },
  { dial: "+48",  name: "Poland" },
  { dial: "+351", name: "Portugal" },
  { dial: "+974", name: "Qatar" },
  { dial: "+40",  name: "Romania" },
  { dial: "+7",   name: "Russia" },
  { dial: "+966", name: "Saudi Arabia" },
  { dial: "+65",  name: "Singapore" },
  { dial: "+27",  name: "South Africa" },
  { dial: "+82",  name: "South Korea" },
  { dial: "+34",  name: "Spain" },
  { dial: "+94",  name: "Sri Lanka" },
  { dial: "+46",  name: "Sweden" },
  { dial: "+41",  name: "Switzerland" },
  { dial: "+886", name: "Taiwan" },
  { dial: "+255", name: "Tanzania" },
  { dial: "+66",  name: "Thailand" },
  { dial: "+216", name: "Tunisia" },
  { dial: "+90",  name: "Turkey" },
  { dial: "+256", name: "Uganda" },
  { dial: "+380", name: "Ukraine" },
  { dial: "+971", name: "UAE" },
  { dial: "+44",  name: "United Kingdom" },
  { dial: "+1",   name: "United States" },
  { dial: "+598", name: "Uruguay" },
  { dial: "+998", name: "Uzbekistan" },
  { dial: "+58",  name: "Venezuela" },
  { dial: "+84",  name: "Vietnam" },
  { dial: "+967", name: "Yemen" },
  { dial: "+260", name: "Zambia" },
  { dial: "+263", name: "Zimbabwe" },
];

export function getCountryName(code) {
  return COUNTRY_NAMES[code] || code || "";
}

export function isValidCountryCode(code) {
  return typeof code === "string" && Object.prototype.hasOwnProperty.call(COUNTRY_NAMES, code);
}
